import { apiFetch } from "@/lib/api";

interface Envelope<T> {
  data: T;
}

export interface MemberOnboardingStep {
  key: string;
  done: boolean;
}

export interface MemberOnboardingFlow {
  /** The caller's role for this client's flow, or null if they have no flow here. */
  role: "team_leader" | "staff" | null;
  steps: MemberOnboardingStep[];
  completed_at: string | null;
  /** Every assigned TL/Staff member's progress — for CD/TL oversight. */
  team: {
    member_id: string;
    name: string;
    role: string;
    completed_steps: string[];
    total_steps: number;
    completed_at: string | null;
  }[];
}

/** GET /clients/<id>/member-onboarding — the caller's role-specific flow. */
export async function getMemberOnboarding(clientId: string): Promise<MemberOnboardingFlow> {
  const body = await apiFetch<Envelope<MemberOnboardingFlow>>(
    `/clients/${clientId}/member-onboarding/`,
  );
  return body.data;
}

/** POST /clients/<id>/member-onboarding/step — toggle one step. */
export async function setOnboardingStep(
  clientId: string,
  step: string,
  done: boolean,
): Promise<{ steps: MemberOnboardingStep[]; completed_at: string | null }> {
  const body = await apiFetch<Envelope<{ steps: MemberOnboardingStep[]; completed_at: string | null }>>(
    `/clients/${clientId}/member-onboarding/step/`,
    { method: "POST", json: { step, done } },
  );
  return body.data;
}

export interface MyOnboardingClient {
  id: string;
  name: string;
  completed_steps: number;
  total_steps: number;
}

/** GET /clients/my-onboarding — clients assigned to me still to onboard. */
export async function listMyOnboarding(): Promise<MyOnboardingClient[]> {
  const body = await apiFetch<Envelope<MyOnboardingClient[]>>(
    "/clients/my-onboarding/?page_size=50",
  );
  return body.data;
}
